<template>
	<div>
		<Card>
			<Form ref="searchForm" :model="searchForm" inline :label-width="100">
				<FormItem :label="$t('WithDrawRecord.WithdrawNo')">
					<Input v-model="searchForm.withdrawNo" :placeholder="$t('WithDrawRecord.PleaseEnterWithdrawNo')" style="width: 200px" clearable />
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.Station')">
					<Select v-model="searchForm.stationId" :placeholder="$t('WithDrawRecord.SelectStation')" style="width: 200px" clearable>
						<Option v-for="item in stationList" :key="item.StationId" :value="String(item.StationId)">
							{{ item.StationName || '-' }}
						</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.WithdrawStatus')">
					<Select v-model="searchForm.withdrawStatus" :placeholder="$t('WithDrawRecord.SelectStatus')" style="width: 150px" clearable>
						<Option value="0">{{ $t('WithDrawRecord.StatusPending') }}</Option>
						<Option value="1">{{ $t('WithDrawRecord.StatusProcessing') }}</Option>
						<Option value="2">{{ $t('WithDrawRecord.StatusSuccess') }}</Option>
						<Option value="3">{{ $t('WithDrawRecord.StatusFailed') }}</Option>
						<Option value="4">{{ $t('WithDrawRecord.StatusCancelled') }}</Option>
					</Select>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.ApplyTime')">
					<DatePicker
						v-model="searchForm.dateRange"
						type="daterange"
						:placeholder="$t('WithDrawRecord.SelectDateRange')"
						style="width: 300px"
						clearable
					/>
				</FormItem>
				<FormItem>
					<Button type="primary" @click="handleSearch">{{ $t('Common.Search') }}</Button>
					<Button type="default" @click="handleReset" style="margin-left: 8px;">{{ $t('Common.Reset') }}</Button>
				</FormItem>
			</Form>
		</Card>

		<Card>
			<Table border :columns="columns" :data="tableData" :loading="tableLoading">
				<template #withdrawStatus="{ row }">
					<Tag :color="getWithdrawStatusColor(row.WithdrawStatus)">
						{{ getWithdrawStatusText(row.WithdrawStatus) }}
					</Tag>
				</template>
				<template #withdrawAmount="{ row }">
					<span style="color: #52c41a; font-weight: bold;">¥{{ formatMoney(row.WithdrawAmount) }}</span>
				</template>
				<template #serviceFee="{ row }">
					<span style="color: #f5222d;">¥{{ formatMoney(row.ServiceFee) }}</span>
				</template>
				<template #actualAmount="{ row }">
					<span style="color: #1890ff; font-weight: bold;">¥{{ formatMoney(row.ActualAmount) }}</span>
				</template>
				<template #applyTime="{ row }">
					{{ formatDateTime(row.ApplyTime) }}
				</template>
				<template #finishTime="{ row }">
					{{ row.FinishTime ? formatDateTime(row.FinishTime) : '-' }}
				</template>
				<template #action="{ row }">
					<Button type="primary" size="small" @click="handleViewDetail(row)" style="margin-right: 5px;">{{ $t('WithDrawRecord.ViewDetail') }}</Button>
					<Button type="success" size="small" @click="handleManualTransfer(row)">{{ $t('WithDrawRecord.ManualTransfer') }}</Button>
				</template>
			</Table>
			<div style="margin-top: 16px; text-align: right;">
				<Page
					:total="pagination.total"
					:current="pagination.current"
					:page-size="pagination.pageSize"
					:page-size-opts="[10, 20, 50, 100]"
					show-total
					show-sizer
					@on-change="handlePageChange"
					@on-page-size-change="handlePageSizeChange"
				/>
			</div>
		</Card>

		<!-- ���鵯�� -->
		<Modal
			v-model="detailVisible"
			:title="$t('WithDrawRecord.WithdrawDetail')"
			:mask-closable="false"
			@on-cancel="handleDetailCancel"
			width="800"
		>
			<Form :label-width="120" style="margin-top: 10px;">
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.WithdrawNo')">
							<span>{{ currentDetail.WithdrawNo || '-' }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.WithdrawStatus')">
							<Tag :color="getWithdrawStatusColor(currentDetail.WithdrawStatus)">
								{{ getWithdrawStatusText(currentDetail.WithdrawStatus) }}
							</Tag>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.OperatorId')">
							<span>{{ currentDetail.OperatorId || '-' }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.StationId')">
							<span>{{ currentDetail.StationId || '-' }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="24">
						<FormItem :label="$t('WithDrawRecord.WithdrawAmount')">
							<span style="color: #52c41a; font-weight: bold; font-size: 18px;">¥{{ formatMoney(currentDetail.WithdrawAmount) }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ServiceFee')">
							<span style="color: #f5222d;">¥{{ formatMoney(currentDetail.ServiceFee) }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ActualAmount')">
							<span style="color: #1890ff; font-weight: bold; font-size: 16px;">¥{{ formatMoney(currentDetail.ActualAmount) }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ChannelTradeNo')">
							<span>{{ currentDetail.ChannelTradeNo || '-' }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ChannelPayoutNo')">
							<span>{{ currentDetail.ChannelPayoutNo || '-' }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ApplyUser')">
							<span>{{ currentDetail.ApplyUserName || '-' }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.ApplyTime')">
							<span>{{ formatDateTime(currentDetail.ApplyTime) }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.TransferTime')">
							<span>{{ currentDetail.TransferTime ? formatDateTime(currentDetail.TransferTime) : '-' }}</span>
						</FormItem>
					</Col>
					<Col span="12">
						<FormItem :label="$t('WithDrawRecord.FinishTime')">
							<span>{{ currentDetail.FinishTime ? formatDateTime(currentDetail.FinishTime) : '-' }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16" v-if="currentDetail.FailReason">
					<Col span="24">
						<FormItem :label="$t('WithDrawRecord.FailReason')">
							<span style="color: #f5222d;">{{ currentDetail.FailReason }}</span>
						</FormItem>
					</Col>
				</Row>
				<Row :gutter="16">
					<Col span="24">
						<FormItem :label="$t('WithDrawRecord.Remark')">
							<span>{{ currentDetail.Remark || '-' }}</span>
						</FormItem>
					</Col>
				</Row>
			</Form>
			<div slot="footer">
				<Button type="primary" @click="handleDetailCancel">{{ $t('Common.Cancel') }}</Button>
			</div>
		</Modal>

		<!-- �ֶ�ת�˵��� -->
		<Modal
			v-model="manualTransferVisible"
			:title="$t('WithDrawRecord.ManualTransfer')"
			:mask-closable="false"
			width="600"
		>
			<Form ref="transferForm" :model="transferForm" :rules="transferRules" :label-width="120">
				<FormItem :label="$t('WithDrawRecord.WithdrawNo')">
					<span>{{ (currentTransferRecord && currentTransferRecord.WithdrawNo) || '-' }}</span>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.StationName')">
					<span>{{ (currentTransferRecord && currentTransferRecord.StationName) || '-' }}</span>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.WithdrawAmount')">
					<span style="color: #52c41a; font-weight: bold; font-size: 18px;">
						¥{{ formatMoney((currentTransferRecord && currentTransferRecord.WithdrawAmount) || 0) }}
					</span>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.ActualAmount')">
					<span style="color: #1890ff; font-weight: bold; font-size: 16px;">
						¥{{ formatMoney(calculateActualAmount()) }}
					</span>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.WithdrawAccount')">
					<span>{{ (transferAccount && transferAccount.ReceiveAccount) || '-' }}</span>
				</FormItem>
				<FormItem :label="$t('WithDrawAccount.AccountName')">
					<span>{{ (transferAccount && transferAccount.AccountName) || '-' }}</span>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.Channel')">
					<Tag :color="(transferAccount && transferAccount.Channel === 'stripe') ? 'purple' : 'default'">
						{{ transferAccount ? (transferAccount.Channel === 'stripe' ? this.$t('WithDrawAccount.Stripe') : transferAccount.Channel) : '-' }}
					</Tag>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.ServiceFee')" prop="serviceFee">
					<Input
						v-model="transferForm.serviceFeeStr"
						:placeholder="$t('WithDrawRecord.PleaseEnterServiceFee')"
						style="width: 100%;"
						@on-blur="handleServiceFeeBlur"
					>
						<span slot="prepend">¥</span>
					</Input>
				</FormItem>
				<FormItem :label="$t('WithDrawRecord.Remark')" prop="remark">
					<Input v-model="transferForm.remark" type="textarea" :rows="4" :placeholder="$t('WithDrawRecord.PleaseEnterRemark')" />
				</FormItem>
			</Form>
			<div slot="footer">
				<Button @click="handleManualTransferCancel">{{ $t('Common.Cancel') }}</Button>
				<Button type="primary" @click="handleManualTransferOk" :loading="manualTransferLoading">{{ $t('Common.Confirm') }}</Button>
			</div>
		</Modal>
	</div>
</template>

<script>
import webapi from '@/webapi';

export default {
	name: 'WithDrawRecord',
	data() {
		return {
			searchForm: {
				withdrawNo: '',
				stationId: '',
				withdrawStatus: '',
				dateRange: []
			},
			tableData: [],
			tableLoading: false,
			pagination: {
				current: 1,
				pageSize: 10,
				total: 0
			},
			stationList: [],
			columns: [],
			detailVisible: false,
			currentDetail: {},
			manualTransferVisible: false,
			manualTransferLoading: false,
			currentTransferRecord: null,
			transferAccount: null,
			transferForm: {
				serviceFee: 0,
				serviceFeeStr: '0',
				remark: ''
			},
			transferRules: {}
		};
	},
	watch: {
		// 监听语言变化，重新初始化列定义和验证规则
		'$i18n.locale'() {
			this.initColumns();
			this.initTransferRules();
		}
	},
	created() {
		this.initColumns();
		this.initTransferRules();
		this.getStationList();
		this.getWithdrawRecordList();
	},
	methods: {
		// ��ʼ�������б�
		initColumns() {
			this.columns = [
				{
					title: this.$t('SplitRule.Index'),
					type: 'index',
					width: 70,
					align: 'center'
				},
				{
					title: this.$t('WithDrawRecord.WithdrawNo'),
					key: 'WithdrawNo',
					minWidth: 200,
					fixed: 'left'
				},
				{
					title: this.$t('WithDrawRecord.StationName'),
					key: 'StationName',
					minWidth: 150
				},
				{
					title: this.$t('WithDrawRecord.WithdrawAmount'),
					slot: 'withdrawAmount',
					width: 120,
					align: 'right'
				},
				{
					title: this.$t('WithDrawRecord.ServiceFee'),
					slot: 'serviceFee',
					width: 120,
					align: 'right'
				},
				{
					title: this.$t('WithDrawRecord.ActualAmount'),
					slot: 'actualAmount',
					width: 120,
					align: 'right'
				},
				{
					title: this.$t('WithDrawRecord.WithdrawStatus'),
					slot: 'withdrawStatus',
					width: 100,
					align: 'center'
				},
				{
					title: this.$t('WithDrawRecord.ApplyUser'),
					key: 'ApplyUserName',
					width: 120
				},
				{
					title: this.$t('WithDrawRecord.ApplyTime'),
					slot: 'applyTime',
					width: 180
				},
				{
					title: this.$t('WithDrawRecord.FinishTime'),
					slot: 'finishTime',
					width: 180
				},
				{
					title: this.$t('SplitRule.Operation'),
					slot: 'action',
					width: 180,
					align: 'center',
					fixed: 'right'
				}
			];
		},

		// ��ʼ��ת�˱�����֤����
		initTransferRules() {
			this.transferRules = {
				serviceFee: [
					{ required: true, type: 'number', message: this.$t('WithDrawRecord.PleaseEnterServiceFee'), trigger: 'change' },
					{ validator: this.validateServiceFee, trigger: 'blur' }
				],
				remark: [
					{ required: true, message: this.$t('WithDrawRecord.PleaseEnterRemark'), trigger: 'blur' }
				]
			};
		},

		// ��ȡ��վ�б�
		async getStationList() {
			try {
				const res = await this.$axios.post(webapi.base_api_url + '/Home/GetCurrentUserStations', {});
				if (res.status === 200 && res.data.Code === 0) {
					this.stationList = res.data.Data.List || [];
				}
			} catch (error) {
				console.error('��ȡ��վ�б�ʧ��:', error);
			}
		},

		// ��ȡ���ּ�¼�б�
		async getWithdrawRecordList() {
			this.tableLoading = true;
			try {
				const params = {
					withdrawNo: this.searchForm.withdrawNo,
					stationId: this.searchForm.stationId ? Number(this.searchForm.stationId) : null,
					withdrawStatus: this.searchForm.withdrawStatus ? Number(this.searchForm.withdrawStatus) : null,
					startTime: this.searchForm.dateRange.length > 0 ? this.searchForm.dateRange[0] : '',
					endTime: this.searchForm.dateRange.length > 1 ? this.searchForm.dateRange[1] : '',
					pageIndex: this.pagination.current,
					pageSize: this.pagination.pageSize
				};

				const res = await this.$axios.post(webapi.base_api_url + '/Split/GetWithdrawRecords', params);

				if (res.status === 200 && res.data.Code === 0) {
					this.tableData = res.data.Data.List || [];
					this.pagination.total = res.data.Data.Total || 0;
				} else {
					this.$Message.error(res.data.Message || this.$t('WithDrawRecord.GetWithdrawRecordListFail'));
					this.tableData = [];
					this.pagination.total = 0;
				}
			} catch (error) {
				console.error('��ȡ���ּ�¼ʧ��:', error);
				this.$Message.error(this.$t('WithDrawRecord.GetWithdrawRecordListFail'));
				this.tableData = [];
				this.pagination.total = 0;
			} finally {
				this.tableLoading = false;
			}
		},

		// ����
		handleSearch() {
			this.pagination.current = 1;
			this.getWithdrawRecordList();
		},

		// ����
		handleReset() {
			this.searchForm = {
				withdrawNo: '',
				stationId: '',
				withdrawStatus: '',
				dateRange: []
			};
			this.pagination.current = 1;
			this.getWithdrawRecordList();
		},

		// ��ҳ�仯
		handlePageChange(page) {
			this.pagination.current = page;
			this.getWithdrawRecordList();
		},

		// ÿҳ�����仯
		handlePageSizeChange(pageSize) {
			this.pagination.pageSize = pageSize;
			this.pagination.current = 1;
			this.getWithdrawRecordList();
		},

		// �鿴����
		handleViewDetail(row) {
			this.currentDetail = row;
			this.detailVisible = true;
		},

		// �ֶ�ת��
		async handleManualTransfer(row) {
			this.currentTransferRecord = { ...row };
			this.transferAccount = null;
			this.transferForm.serviceFee = 0;
			this.transferForm.serviceFeeStr = '0';
			this.transferForm.remark = '';
			this.manualTransferVisible = true;

			// ���ýӿڻ�ȡ�����˺���Ϣ
			if (row.WithdrawAccountId) {
				await this.getWithdrawAccountById(row.WithdrawAccountId);
			}
		},

		// ��ȡ�����˺�����
		async getWithdrawAccountById(accountId) {
			try {
				const params = {
					id: accountId
				};

				const res = await this.$axios.post(webapi.base_api_url + '/Split/GetWithdrawAccountById', params);

				if (res.status === 200 && res.data.Code === 0) {
					this.transferAccount = res.data.Data;
				} else {
					this.$Message.error(res.data.Message || this.$t('WithDrawRecord.GetWithdrawAccountInfoFail'));
					this.transferAccount = null;
				}
			} catch (error) {
				console.error('��ȡ�����˺���Ϣʧ��:', error);
				this.$Message.error(this.$t('WithDrawRecord.GetWithdrawAccountInfoFail'));
				this.transferAccount = null;
			}
		},

		// ȷ���ֶ�ת��
		handleManualTransferOk() {
			this.$refs.transferForm.validate(async (valid) => {
				if (valid) {
					this.manualTransferLoading = true;
					try {
						const params = {
							withdrawNo: this.currentTransferRecord.WithdrawNo,
							serviceFee: this.transferForm.serviceFee,
							remark: this.transferForm.remark
						};

						const res = await this.$axios.post(webapi.base_api_url + '/Split/ManualTransfer', params);

						if (res.status === 200 && res.data.Code === 0) {
							this.$Message.success(this.$t('WithDrawRecord.ManualTransferSuccess'));
							this.manualTransferVisible = false;
							this.getWithdrawRecordList();
						} else {
							this.$Message.error(res.data.Message || this.$t('WithDrawRecord.ManualTransferFail'));
						}
					} catch (error) {
						console.error('�ֶ�ת��ʧ��:', error);
						this.$Message.error(this.$t('WithDrawRecord.ManualTransferFail'));
					} finally {
						this.manualTransferLoading = false;
					}
				}
			});
		},

		// ȡ���ֶ�ת��
		handleManualTransferCancel() {
			this.manualTransferVisible = false;
			this.$refs.transferForm && this.$refs.transferForm.resetFields();
			this.currentTransferRecord = null;
			this.transferAccount = null;
		},

		// �ر����鵯��
		handleDetailCancel() {
			this.detailVisible = false;
			this.currentDetail = {};
		},

		// ��ȡ����״̬�ı�
		getWithdrawStatusText(status) {
			const map = {
				0: this.$t('WithDrawRecord.StatusPending'),
				1: this.$t('WithDrawRecord.StatusProcessing'),
				2: this.$t('WithDrawRecord.StatusSuccess'),
				3: this.$t('WithDrawRecord.StatusFailed'),
				4: this.$t('WithDrawRecord.StatusCancelled')
			};
			return map[status] || this.$t('WithDrawRecord.StatusUnknown');
		},

		// ��ȡ����״̬��ɫ
		getWithdrawStatusColor(status) {
			const map = {
				0: 'default',
				1: 'processing',
				2: 'success',
				3: 'error',
				4: 'warning'
			};
			return map[status] || 'default';
		},

		// ��ʽ�����
		formatMoney(amount) {
			if (amount === null || amount === undefined || amount === '') return '0.00';
			return Number(amount).toFixed(2);
		},

		// ��ʽ������ʱ��
		formatDateTime(dateTime) {
			if (!dateTime) return '-';
			const date = new Date(dateTime);
			const year = date.getFullYear();
			const month = String(date.getMonth() + 1).padStart(2, '0');
			const day = String(date.getDate()).padStart(2, '0');
			const hours = String(date.getHours()).padStart(2, '0');
			const minutes = String(date.getMinutes()).padStart(2, '0');
			const seconds = String(date.getSeconds()).padStart(2, '0');
			return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
		},

		// ������ʧ������
		handleServiceFeeBlur() {
			let fee = parseFloat(this.transferForm.serviceFeeStr);

			if (isNaN(fee) || fee < 0) {
				fee = 0;
			}

			const withdrawAmount = (this.currentTransferRecord && this.currentTransferRecord.WithdrawAmount) || 0;
			if (fee > withdrawAmount) {
				this.$Message.warning(this.$t('WithDrawRecord.ServiceFeeExceed'));
				fee = withdrawAmount;
			}

			this.transferForm.serviceFee = parseFloat(fee.toFixed(2));
			this.transferForm.serviceFeeStr = this.transferForm.serviceFee.toFixed(2);
		},

		// ����ʵ�ʵ��˽��
		calculateActualAmount() {
			const withdrawAmount = (this.currentTransferRecord && this.currentTransferRecord.WithdrawAmount) || 0;
			const serviceFee = this.transferForm.serviceFee || 0;
			const actualAmount = withdrawAmount - serviceFee;
			return Math.max(0, actualAmount);
		},

		// ��֤������
		validateServiceFee(rule, value, callback) {
			const fee = parseFloat(this.transferForm.serviceFeeStr);
			const withdrawAmount = (this.currentTransferRecord && this.currentTransferRecord.WithdrawAmount) || 0;

			if (isNaN(fee) || fee < 0) {
				callback(new Error(this.$t('WithDrawRecord.InvalidServiceFee')));
			} else if (fee > withdrawAmount) {
				callback(new Error(this.$t('WithDrawRecord.ServiceFeeExceed')));
			} else {
				callback();
			}
		}
	}
};
</script>

<style scoped>
:deep(.ivu-form-item) {
	margin-bottom: 16px;
}
</style>
